// FeedbackForm.tsx
import React, { useState } from 'react';
import {
    Box,
    Button,
    Alert,
    MenuItem,
    TextField,
    Stack,
} from '@mui/material';
import { useAuth } from '../../hooks/useAuth';

interface FeedbackFormProps {
    onSubmit?: (feedback: FeedbackData) => void;
}

interface FeedbackData {
    name: string;
    email: string;
    message: string;
    rating: number;
}

export const FeedbackForm: React.FC<FeedbackFormProps> = ({ onSubmit }) => {
    const { userName, } = useAuth();
    
    const [formData, setFormData] = useState<FeedbackData>({
        name: userName || '',
        email: userName || '',
        message: '',
        rating: 5,
    });

    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: name === 'rating' ? parseInt(value) : value,
        }));
    };

    const handleSubmit = () => {
        try {
            onSubmit?.(formData);
            setIsSubmitted(true);
            setFormData({ name: '', email: '', message: '', rating: 5 });
            setTimeout(() => setIsSubmitted(false), 3000);
        } catch (error) {
            console.error('Failed to submit feedback:', error);
            // Optionally, you can set an error state here to show an error message to the user.
        }
    };

    return (
        <Box>
            <Stack spacing={2}>
                <TextField
                    label="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    fullWidth
                />

                <TextField
                    label="Email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    fullWidth
                />

                <TextField
                    select
                    label="Rating"
                    name="rating"
                    value={formData.rating}
                    onChange={handleChange}
                    fullWidth
                >
                    {[1, 2, 3, 4, 5].map((num) => (
                        <MenuItem key={num} value={num}>
                            {num} Star{num > 1 ? 's' : ''}
                        </MenuItem>
                    ))}
                </TextField>

                <TextField
                    label="Message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    fullWidth
                    multiline
                    rows={5}
                />

                <Button variant="contained" onClick={handleSubmit}>
                    Submit Feedback
                </Button>

                {isSubmitted && (
                    <Alert severity="success">Thank you for your feedback!</Alert>
                )}
            </Stack>
        </Box>
    );
};